/* eslint-disable */
import React, { Component } from "react";
import { Auth } from 'aws-amplify';

class NotAnEmployee extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    refreshPage = () => {
        window.location.reload();
    }

    render() {
        return (
            <div>
                {`Must be an employee of recyclops to access.`}
                <button onClick={this.refreshPage}>Refresh</button>
                <button onClick={() => Auth.signOut()}>Return to Login Page</button>
            </div>
        );
    }
}

export default NotAnEmployee